import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    askSituationTitle: 'Our offers are adapted to your needs',
    back: 'Back',
  },
  fr: {
    askSituationTitle: 'Nos offres s’adaptent à vos besoins',
    back: 'Retour',
  },
} as const);
